import { useContext, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { gtm } from 'lib/gtm'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import useCurrentUser from 'lib/hooks/useCurrentUser'

import { AuthContext } from 'components/Auth/Auth'

const GTMComponent = ({ primaryCategory, pageType }) => {
    const currentUser = useCurrentUser()
    const location = useLocation()
    const match = useRouteMatch()

    const auth = useContext(AuthContext)
    const almaUser = auth?.almaAuthData?.user

    // list of routes where we should not push pageView events automatically
    // the view will push the event when it sees fit (e.g. when all the required data is loaded and available)
    const pageViewEventSkipRoutes = useMemo(() => [
        '/:lang(en)?/fiksut-kaupat/sahkoinen-kauppakirja/:bosId/katsele',
        '/:lang(en)?/fiksut-kaupat/sahkoinen-kauppakirja/:bosId/muokkaa',
        '/:lang(en)?/fiksut-kaupat/sahkoinen-kauppakirja/:bosId/pyynto/:requestId/vaihe/:task/:status',
        '/:lang(en)?/bill-of-sale/:bosId/payment',
        '/:lang(en)?/fiksut-kaupat/sahkoinen-kauppakirja/:bosId/maksu/onnistunut',
        '/:lang(en)?/fiksut-kaupat/sahkoinen-kauppakirja/:bosId(\\d+)',
    ], [])

    const pushPageView = useCallback((pathname) => {
        if (pageViewEventSkipRoutes.includes(match.path)) {
            return
        }
        gtm.pushPageView(pathname)
    }, [pageViewEventSkipRoutes, match])

    const pushAlmaDigitalData = useCallback(() => {
        gtm.pushAlmaDigitalData(pageType, primaryCategory)
    }, [pageType, primaryCategory])

    useEffect(() => {
        gtm.setCurrentUser(currentUser, almaUser)
        pushPageView(location.pathname)
        pushAlmaDigitalData()
    }, [currentUser, almaUser, pushPageView, pushAlmaDigitalData, location])

    return null
}

GTMComponent.propTypes = {
    primaryCategory: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender
)(GTMComponent)
